<template>
    <div id="app">
        <transition>
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    import routes from 'src/router/index.js';
    import {mapActions} from 'vuex';
    export default {
        data () {
            return {

            };
        },
        created () {
            let that = this,
                cookieToken = localStorage.getItem('token'),
                perms = JSON.parse(localStorage.getItem('perms'));

            if (cookieToken) {
                // 登录的时候添加路由
                routes.getMenu(function (route) {
                    for (let x of route) {
                        that.$router.addRoute(x);
                    }
                });

                if (perms.length > 0) {
                    perms && Array.isArray(perms) && that.setPermission(perms);
                }
            }
        },
        methods: {
            ...mapActions([
                'setPermission'
            ])
        }
    };
</script>



// WEBPACK FOOTER //
// src/App.vue